import ReactModal from 'react-modal'

import CardStack from '~/components/CardStack'
import { isPublisher, isReadOnly } from '~/helpers'

import { useReviewMediaQueue } from './hooks/useReviewMediaQueue'
import { useTransparentModalStyle } from './hooks/useTransparentModalStyle'
import ReviewMediaCard from './ReviewMediaCard'

import * as S from './styles'

const ReviewMediaModal = ({
  onClose,
  initialItemId
}: ReviewMediaModalProps) => {
  const modalStyle = useTransparentModalStyle(9999)
  const {
    currentItem,
    currentIndex,
    displayItems,
    mode,
    setMode,
    animateTransition,
    approveBanner,
    rejectBanner,
    handleApprove,
    handleReject,
    handleGoNext,
    handleGoPrev
  } = useReviewMediaQueue({ initialItemId, onClose })

  if (!currentItem) {
    return null
  }

  const hasMultipleItems = displayItems.length > 1

  const renderCard = (item: AdsResultFormatted, isFocused: boolean) => {
    if (!isFocused) {
      return null
    }

    const canReview =
      item.status === 'pending_review' && isPublisher() && !isReadOnly()

    return (
      <ReviewMediaCard
        item={item}
        isRejecting={mode === 'reject'}
        hasMultipleItems={hasMultipleItems}
        currentIndex={currentIndex}
        total={displayItems.length}
        canReview={canReview}
        approvePending={approveBanner.isPending}
        rejectPending={rejectBanner.isPending}
        onClose={onClose}
        onApprove={handleApprove}
        onReject={() => setMode('reject')}
        onCancelReject={() => setMode('view')}
        onSubmitReject={({ note }) => handleReject(note)}
      />
    )
  }

  return (
    <ReactModal
      isOpen
      onRequestClose={onClose}
      ariaHideApp={false}
      style={modalStyle}
      data-testid="review-media-modal"
    >
      <S.Wrapper>
        <CardStack
          items={displayItems}
          currentIndex={currentIndex}
          onNext={handleGoNext}
          onPrev={handleGoPrev}
          getKey={item => item.id}
          renderCard={renderCard}
          animateTransitions={animateTransition}
        />
      </S.Wrapper>
    </ReactModal>
  )
}

export default ReviewMediaModal
